import React from "react";
import "../../Styles/yellowcalf.css/Failed_Wallet_Recharge.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlassPlus } from "@fortawesome/free-solid-svg-icons";

function FailedWallets() {
  return (
    <div className="fw-container" style={{ paddingTop: "25px" }}>
      <div className="fw-main-panel">
        <h3 className="fw-panel-title">Failed Wallets</h3>
      </div>

      {/* Filters + table panel */}
      <div className="fw-panel fw-secondary-panel">
        <div className="fw-filters" style={{marginTop:'-24px'}}>
          <select className="fw-input">
            <option>All Students</option>
            <option>John Doe</option>
            <option>Jane Smith</option>
          </select>

   <div style={{ position: "relative" }}>
  <i
    className="bi bi-search"
    style={{
      position: "absolute",
      left: "12px",
      top: "50%",
      transform: "translateY(-50%)",
      color: "#7d7f82ff",
      fontSize: "14px",
    }}
  />
  <input
    type="text"
    className="fw-input"
    placeholder="Start date / search"
    style={{ paddingLeft: "35px" }}
  />
</div>

<div style={{ position: "relative" }}>
  <i
    className="bi bi-search"
    style={{
      position: "absolute",
      left: "12px",
      top: "50%",
      transform: "translateY(-50%)",
      color: "#7d7f82ff",
      fontSize: "14px",
    }}
  />
  <input
    type="text"
    className="fw-input"
    placeholder="End date / search"
    style={{ paddingLeft: "35px" }}
  />
</div>



          <button className="fw-clear-btn">Clear</button>
        </div>

        <div className="fw-table-wrapper" style={{fontSize:'13px'}}>
          <table className="fw-table" style={{marginTop:'-10px'}}>
            <thead style={{height:'60px', textAlign:'center'}}>
              <tr>
                <th style={{ textAlign: "center" }}>Sr.NO</th>
                <th style={{ textAlign: "center" }}>Student</th>
                <th style={{ textAlign: "center" }}>Amount</th>
                <th style={{ textAlign: "center" }}>Date Time</th>
                <th style={{ textAlign: "center" }}>Recharge ID</th>
                <th style={{ textAlign: "center" }}>Reference No</th>
                <th style={{ textAlign: "center" }}>Recharge Mode</th>
                <th style={{ textAlign: "center" }}>Operator</th>
                <th style={{ textAlign: "center" }}>Status</th>
                <th style={{ textAlign: "center" }}>Action</th>
              </tr>
            </thead>

            <tbody>
              <tr style={{ height: "15px" }}>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>1</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>John Doe</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>₹500</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>2025-09-24 14:30</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>RCG12345</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>REF998877</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>Online</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>Paytm</td>   
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>Failed</td>
                <td>
                  <a
                    href="/accountant/failedtransaction/rechargeview?id=492"
                    className="fw-view-btn"
                    title="View"
                  >
                    <i class="bi bi-eye" style={{marginLeft:'20px'}} ></i>
                  </a>
                </td>
              </tr>

              <tr style={{height:'15px'}}>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>2</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>Jane Smith</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>₹1000</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>2025-09-23 12:00</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>RCG12346</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>REF998878</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>PayFort</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>Paytm</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>Failed</td>
                <td>
                  <a
                    href="/accountant/failedtransaction/rechargeview?id=493"
                    className="fw-view-btn"
                    title="View"
                  >
                    <i class="bi bi-eye" style={{marginLeft:'20px'}} ></i>
                  </a>
                </td>
              </tr>

              <tr style={{height:'15px'}}>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>3</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>Jane Smith</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>₹1000</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>2025-09-23 12:00</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>RCG12346</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>REF998878</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>PayFort</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>Paytm</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>Failed</td>
                <td>
                  <a
                    href="/accountant/failedtransaction/rechargeview?id=493"
                    className="fw-view-btn"
                    title="View"
                  >
                    <i class="bi bi-eye" style={{marginLeft:'20px'}} ></i>
                  </a>
                </td>
              </tr>

              <tr style={{height:'15px'}}>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>4</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>Jane Smith</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>₹1000</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>2025-09-23 12:00</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>RCG12346</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>REF998878</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>PayFort</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>Paytm</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>Failed</td>
                <td>
                  <a
                    href="/accountant/failedtransaction/rechargeview?id=493"
                    className="fw-view-btn"
                    title="View"
                  >
                    <i class="bi bi-eye" style={{marginLeft:'20px'}} ></i>
                  </a>
                </td>
              </tr>

              <tr style={{height:'15px'}}>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>5</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>Jane Smith</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>₹1000</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>2025-09-23 12:00</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>RCG12346</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>REF998878</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>PayFort</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>Paytm</td>
                <td style={{ lineHeight: "15px", textAlign: "center", verticalAlign: "middle" }}>Failed</td>
                <td>
                  <a
                    href="/accountant/failedtransaction/rechargeview?id=493"
                    className="fw-view-btn"
                    title="View"
                 >
                    <i class="bi bi-eye" style={{marginLeft:'20px'}} ></i>
                  </a>
                </td>
              </tr>

            </tbody>
          </table>
          <div style={{ padding: '20px', marginTop:'-20px' }}>
      <div
        style={{
          flex: '1',
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: '8px',
        }}
      >
     
        <div style={{ color: '#333', fontSize: '14px' }}>
          Showing 1 to 10 of 177 entries
        </div>

        <ul
          style={{
            display: 'flex',
            listStyle: 'none',
            gap: '6px',
            margin: 0,
            padding: 0,
          }}
        >
          {['1', '2', '3'].map((num) => (
            <li key={num}>
              <a
                href="#"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '28px',
                  height: '28px',
                  border: '1px solid #6dd4f0',
                  backgroundColor: num === '1' ? '#4fa3e8' : '#edf5f7ff', 
                  color: '#171717ff',
                  borderRadius: '4px',
                  fontSize: '12px',
                  textDecoration: 'none',
                }}
              >
                {num}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
        </div>
      </div>
    </div>
  );
}

export default FailedWallets;
